import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { ListQuery } from "./models/ListQuery";
import { ListService } from "./services/ListService";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import ScrollBottom from "../../shared/components/ScrollBottom/ScrollBottom.vue";
import { LIST_ACCESS, LIST_CONSTANTS } from "./constants/ListConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import { Response } from "../../shared/models/Response";
import { ListPagination } from "./models/ListPagination";
import ListItem from "@/shared/components/ListItem/ListItem.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import {
  CHART_TYPES,
  GENERAL_CONSTANTS,
  MANAGED_LISTS_TYPES,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import SaveList from "./components/SaveList/SaveList.vue";
import store from "@/store";
import { SearchContext } from "../../shared/models/SearchContext";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "../../shared/models/MenuDataStructure";
import { Route, NavigationGuardNext } from "vue-router";
import LineChart from "../Dashboards/AdminDashboard/components/Charts/Line/LineChart";
import PieChart from "../Dashboards/AdminDashboard/components/Charts/Pie/PieChart";
import DoughnutChart from "../Dashboards/AdminDashboard/components/Charts/Doughnut/DoughnutChart";
import HorizontalBarChart from "../Dashboards/AdminDashboard/components/Charts/HorizontalBar/HorizontalBarChart";
import BarChart from "../Dashboards/AdminDashboard/components/Charts/Bar/BarChart";
import { FORM_TEMP_CONSTANTS } from "../FormTemplate/constants/FormTemplateConstants";
import { Utils } from "@/shared/utils/utils";
import { ChartRenderData } from "../Dashboards/AdminDashboard/models/ChartRenderData";
import { AxiosError } from "axios";
import { ListStatus } from "./models/ListStatus";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "List",
  components: {
    EmptyState,
    ScrollBottom,
    ListItem,
    ModalTemplate,
    ObservationModal,
    SaveList,
    LineChart,
    PieChart,
    DoughnutChart,
    BarChart,
    HorizontalBarChart
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class List extends Vue {
  @Inject() listService!: ListService;

  dataToMainView!: MenuDataStructure;

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  PAGE_TITLE = LIST_CONSTANTS.PAGE_TITLE;
  ADD_LIST_BTN = LIST_CONSTANTS.BUTTON.ADD_LIST_TEXT;
  OPERATIONS: string[] = [];
  CLICK_ACTION = LIST_DATA_EVENTS.EDIT_DATA;
  TOOLTIP = FORM_TEMP_CONSTANTS.TOOLTIP;

  listId = "";
  listName = "";
  listStatus = "";

  admin = false;

  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  chartTypes = CHART_TYPES;
  isLoadingCharts = false;
  showCharts = false;
  showAddList = false;
  querySearch?: ListQuery = {};
  filterItems = LIST_CONSTANTS.LIST_FILTERS.MAIN;
  initialList?: {
    key: string;
    name: string;
  }[];
  currentChartTypeIndex = 2;
  currentChartType = CHART_TYPES[this.currentChartTypeIndex].value;
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  selectedListId = "";
  currentTooltip = LIST_CONSTANTS.PAGE_TITLE_ADD;
  chartDataGroupName: ChartRenderData = {
    labels: [],
    datasets: [
      {
        data: []
      }
    ]
  };
  chartDataGroupState: ChartRenderData = {
    labels: [],
    datasets: [
      {
        data: []
      }
    ]
  };
  cardClass = STYLE_CLASSES.CARD;

  completeItemList: ListStatus[] = [];
  itemList: ListStatus[] = [];
  paginationStart = 0;
  paginationEnd = 10;

  mounted() {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);

    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
    }

    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.LIST
    );

    this.emitSearchInitializer();
    this.getDataChart();

    if (this.$route.params.id) {
      this.editList(this.$route.params.id);
    }
  }

  async getDataChart() {
    try {
      this.isLoadingCharts = true;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
      );

      const filterQuery: ListQuery = {};

      if (this.querySearch?.name) {
        filterQuery.name = this.querySearch.name;
      }
      if (this.querySearch?.listType) {
        filterQuery.listType = this.querySearch.listType;
      }
      if (this.querySearch?.activeList) {
        filterQuery.activeList = this.querySearch.activeList;
      }
      if (this.querySearch?.isCategoryList) {
        filterQuery.isCategoryList = this.querySearch.isCategoryList;
      }

      const response = await this.listService.getChart(filterQuery);

      if (response.code === Http.Found && response.data != undefined) {
        this.showCharts = true;
        this.chartDataGroupName = {
          labels: Object.keys(response.data["typeListChart"]),
          datasets: [
            {
              data: Object.values(response.data["typeListChart"])
            }
          ]
        };

        this.chartDataGroupState = {
          labels: Object.keys(response.data["statusChart"]),
          datasets: [
            {
              data: Object.values(response.data["statusChart"])
            }
          ]
        };
        this.paginationStart = 0;
        this.paginationEnd = 10;
        this.completeItemList = response.data["listArray"] as ListStatus[];
        this.itemList = this.completeItemList.slice(
          this.paginationStart,
          this.paginationEnd
        );

        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
          this.itemList
        );
      } else {
        this.showCharts = false;
        if (response.code === Http.NotFound) {
          Snackbar.popInfo(response.message);
        } else {
          Snackbar.popError(response.message);
        }
        this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
      }
      this.isLoadingCharts = false;
    } catch (error) {
      this.showCharts = false;
      this.isLoadingCharts = false;
      if ((error as AxiosError).response?.status == Http.Forbidden) {
        const RESPONSE_ERROR: Response<ListPagination> = {
          code: Http.Forbidden,
          message: FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET
        };
        return RESPONSE_ERROR;
      } else {
        const RESPONSE_ERROR: Response<ListPagination> = {
          code: Http.BadRequest,
          message: FORM_MESSAGES.REQUEST_FAILED
        };
        return RESPONSE_ERROR;
      }
    }
  }

  handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editList(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteList(itemId);
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateList(itemId, STATE.ACTIVE);
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateList(itemId, STATE.INACTIVE);
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.restoreListForm();
        break;
    }
  }

  editList(listId: string) {
    this.showSaveList(listId, LIST_CONSTANTS.REFERENCES_TEXTS.EDIT_LIST);
  }

  async deleteList(id: string) {
    try {
      const response = await this.listService.deleteListById(id);

      if (response.code === Http.Ok) {
        Snackbar.popSuccess(LIST_CONSTANTS.DIALOG_MESSAGE.DELETE_LIST_OK);
        this.getDataChart();
      } else if (response.code === Http.Found) {
        Snackbar.popWarning(LIST_CONSTANTS.DIALOG_MESSAGE.LIST_USED);
      } else Snackbar.popError(response.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.DELETE);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async restoreListForm() {
    await this.show(false);
    await this.getDataChart();
  }

  async updateStateList(id: string, state: string) {
    try {
      const responseData = await this.listService.updateStateListById(
        id,
        state
      );
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.restoreListForm();
      } else if (responseData.code === Http.NotFound) {
        Snackbar.popInfo(LIST_CONSTANTS.DIALOG_MESSAGE.ERROR_EDIT_ID_NOT_FOUND);
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.PUT);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async loadInitialList() {
    try {
      const responseData = await this.listService.getListById(
        MANAGED_LISTS_TYPES.IDOF_TYPELIST
      );

      if (responseData.code === Http.NotFound) {
        Snackbar.popInfo(LIST_CONSTANTS.DIALOG_MESSAGE.DEFAULT_LIST_NOT_FOUND);
      } else if (
        responseData.code === Http.Found &&
        responseData.data !== undefined
      ) {
        this.initialList = responseData.data.options.map(data => ({
          key: data.value,
          name: data.title
        }));
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  initializeFilters() {
    this.filterItems.secondaryFilters = [];
    this.filterItems.secondaryFilters.push(
      LIST_CONSTANTS.LIST_FILTERS.SECONDARY.NAME
    );
    this.filterItems.secondaryFilters.push(
      LIST_CONSTANTS.LIST_FILTERS.SECONDARY.STATUS
    );
    if (this.initialList) {
      const typeFilter = LIST_CONSTANTS.LIST_FILTERS.SECONDARY.TYPE;
      typeFilter.options = this.initialList;
      this.filterItems.secondaryFilters.push(typeFilter);
    }
    this.filterItems.secondaryFilters.push(
      LIST_CONSTANTS.LIST_FILTERS.SECONDARY.CATEGORY
    );
  }

  async emitSearchInitializer() {
    await this.loadInitialList();

    this.initializeFilters();

    const searchContext: SearchContext = {
      title: LIST_CONSTANTS.PAGE_TITLE_SEARCH,
      filterArray: [this.filterItems],
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      callbackHandleOperation: this.handleOperation,
      descriptions: ["state", "listType"],
      optionsToFilter: [],
      componentName: COMPONENT_NAME_MODAL.LIST,
      textButtonCreate: LIST_CONSTANTS.PAGE_TITLE_ADD
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      searchContext
    );
  }

  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  @Watch("dataToMainView")
  dataToMainViewHandler() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH
    ) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.querySearch = this.dataToMainView.data;
          this.getDataChart();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.onButtonAdd();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.DO_ON_BOTTOM_CONTEXT:
          this.makePagination();
          break;
      }
    }
  }

  changeChartType(chartType: string) {
    this.currentChartType = chartType;
  }

  changeTitleText(title: string) {
    this.PAGE_TITLE = title;
  }

  onButtonAdd() {
    this.showSaveList("", LIST_CONSTANTS.REFERENCES_TEXTS.ADD_LIST);
  }

  makePagination() {
    if (this.paginationStart < this.completeItemList.length) {
      this.paginationStart = this.paginationEnd;
      this.paginationEnd += 10;
      const itemList = this.completeItemList.slice(
        this.paginationStart,
        this.paginationEnd
      );
      this.itemList = this.itemList.concat(itemList);

      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        this.itemList
      );
    }
  }

  showSaveList(id: string, accion: string) {
    if (accion === LIST_CONSTANTS.REFERENCES_TEXTS.ADD_LIST) {
      if (this.currentIcon === GENERAL_CONSTANTS.ICONS.ADD) {
        this.selectedListId = "";
        this.changeTitleText(LIST_CONSTANTS.PAGE_TITLE_ADD);
        this.show(true);

        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL
        );
      } else {
        this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL);
      }
    } else if (accion === LIST_CONSTANTS.REFERENCES_TEXTS.EDIT_LIST) {
      this.selectedListId = id;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
        id
      );
      this.show(true);
    }
  }

  async show(val: boolean) {
    this.showAddList = val;
    if (val) {
      this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
      this.currentTooltip = FORM_CONSTANTS.BUTTON.CANCEL;
    } else {
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.RESET_SEARCH_CONTEXT
      );
      this.querySearch = {};
      this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
      this.currentTooltip = LIST_CONSTANTS.PAGE_TITLE_ADD;
      this.selectedListId = "";
      this.PAGE_TITLE = LIST_CONSTANTS.PAGE_TITLE;
    }
  }

  async setDataGroupType() {
    delete this.querySearch!.listType;
    await this.getDataChart();
  }

  async typeChartClick(label: string) {
    const graphFilter: any = { ...this.querySearch, listType: [label] };
    this.querySearch = graphFilter;
    await this.getDataChart();
  }

  async setDataGroupState() {
    delete this.querySearch!.activeList;
    await this.getDataChart();
  }

  async stateChartClick(label: string) {
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    const graphFilter: any = { ...this.querySearch, activeList: [label] };
    this.querySearch = graphFilter;
    await this.getDataChart();
  }

  async cancelAction() {
    await this.show(false);
  }
}
